export const ANATOMY_V2_ACCENT_COLOR = '#7B5CFA'
